import {Component, Input, OnInit} from '@angular/core';
import {OfferNumberContext} from '../../../../services/offer-number.service';
import {MatDialog} from '@angular/material';
import {SendCalculationDialogComponent} from '../../../../components/dialogs/send-calculation-dialog/send-calculation-dialog.component';
import {SendCalculationEmailService} from '../../../../../core/services/impl/send-calculation-email.service';
import {AssetsService} from '../../../../services/assets.service';
import {salesChannel} from '../../../../../core/utils/utils';
import {SalesChannel} from '../../../../../core/consts/sales-channel.enum';
import {Ga4EventsConfigService} from '../../../../../core/services/ga4-events-config.service';
import {Ga4OffersElementKey} from '../../../../../core/consts/ga4-offers-element-key.enum';

@Component({
  selector: 'app-send-offer',
  templateUrl: './send-offer.component.html',
  styleUrls: ['./send-offer.component.scss']
})
export class SendOfferComponent implements OnInit {

  @Input() context: OfferNumberContext;
  @Input() buttonVisible: boolean = true;

  get buttonIconPath(): string {
    if ([SalesChannel.BANKIER, SalesChannel.OLX, SalesChannel.MPAY].includes(<SalesChannel>salesChannel())) {
      return `${this.assetsService.getIconsDirectoryPath()}/envelope.svg`;
    }
    return `${this.assetsService.ICONS_MAIN_DIR}/envelope.svg`;
  }

  get sendButtonVisible(): boolean {
    return this.buttonVisible && this.sendCalculationEmailService.buttonVisible;
  }

  constructor(public sendCalculationEmailService: SendCalculationEmailService,
              private ga4EventsService: Ga4EventsConfigService,
              private assetsService: AssetsService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  openDialog(): void {
    this.dialog.open(SendCalculationDialogComponent);
    if (this.sendCalculationEmailService.isOffersStep) {
      this.ga4EventsService.sendOffersElementEvent(Ga4OffersElementKey.SEND_CALCULATION_INIT);
    }
  }

}
